
let save_cart = false;

const setCartWidth = () => {
    if ($('body #shopify-section-header > .cart').hasClass('cart--open')) {
        if ($(window).width() < 768) {
            $('body #shopify-section-header > .cart').width($(window).actual('width'));
        } else {
            $('body #shopify-section-header > .cart').width($(window).actual('width') / 2);
        }
    }
    
    if ($(window).width() < 768) {
        $('body #shopify-section-header > .cart .cart_inner').width($(window).actual('width') - 40);
    } else {
        $('body #shopify-section-header > .cart .cart_inner').width(($(window).actual('width') / 2) - 40);
    }
};

const setSearchWidth = () => {
    if ($('.search_menu').hasClass('search_menu--open')) {
        if ($(window).width() < 768) {
            $('.search_menu').width($(window).actual('width'));
        } else if ($(window).width() < 1024) {
            $('.search_menu').width($(window).actual('width') / 2);
        } else {
            $('.search_menu').width($(window).actual('width') / 4);
        }
    }

    if ($(window).width() < 768) {
        $('.search_menu .search_menu_inner').width($(window).actual('width') - 40);
    } else if ($(window).width() < 1024) {
        $('.search_menu .search_menu_inner').width(($(window).actual('width') / 2) - 40);
    } else {
        $('.search_menu .search_menu_inner').width(($(window).actual('width') / 4) - 40);
    }
};

const setMenuWidth = () => {
    if ($('.navigation').hasClass('navigation--open')) {
        if ($(window).width() < 768) {
            $('.navigation').width($(window).actual('width'));
        } else if ($(window).width() < 1024) {
            $('.navigation').width($(window).actual('width') / 2);
        } else {
            $('.navigation').width($(window).actual('width') / 4);
        }
    }

    if ($(window).width() < 768) {
        $('.navigation .navigation_inner').width($(window).actual('width') - 40);
    } else if ($(window).width() < 1024) {
        $('.navigation .navigation_inner').width(($(window).actual('width') / 2) - 40);
    } else {
        $('.navigation .navigation_inner').width(($(window).actual('width') / 4) - 40);
    }
};

$(document).ready(function() {
    setCartWidth();
    $(window).on('resize', setCartWidth);

    setMenuWidth();
    $(window).on('resize', setMenuWidth);

    setSearchWidth();
    $(window).on('resize', setSearchWidth);

    searchFuncs();
    saleBannerFuncs();
});

$('body').on('click', '.header .cart_btn', function(e) {
    e.preventDefault();
    gsap.to(".cart", { duration: .2, width: $(window).width() < 768 ? $(window).width() : ($(window).actual('width') / 2), ease: "expoScale(0.5,7,none)" }).then(function() {
        $('.cart').addClass('cart--open');
        $('body').addClass('no--scroll');
    });
});

$('body').on('click','.cart .close_btn', function(e) {
    e.preventDefault();
    gsap.to(".cart", { duration: .1, width:0, ease: "expoScale(0.5,7,none)" }).then(function() {
        $('.cart').removeClass('cart--open');
        $('body').removeClass('no--scroll');
    });
});

$('body').on('click', '.cart .cart_inner .remove_btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    
    if (!save_cart) {
        save_cart = true;
        let updates = { [$(this).closest('.cart_row').data('variantid')] : 0 };
        if ($(this).closest('.cart_middle').find('.cart_row').length === 2 && $(this).closest('.cart_middle').find('.cart_row[data-tote="yes"]').length === 1) {
            updates[$(this).closest('.cart_middle').find('.cart_row[data-tote="yes"]').data('variantid')] = 0;
        }
        $('.cart .cart_inner button[type=submit]').attr('disabled', true);
        $('.cart .cart_inner .remove_btn').css('opacity',0);
        $(this).addClass('loading').css('opacity',1);

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates })
        })
        .then(response => {
            loadAjaxCart();
        })
        .catch((error) => {
            $('.cart .cart_inner button[type=submit]').attr('disabled', false);
            $('.cart .cart_inner .remove_btn').css('opacity',1);
            $('.cart .cart_inner .remove_btn.loading').removeClass('loading');
            console.error('Error:', error);
        });
    }
});

$('body').on('click', '.header .search', function(e) {
    e.preventDefault();
    gsap.to(".search_menu", { duration: .2, width: $(window).width() < 768 ? $(window).width() : ($(window).width() >= 768 && $(window).width() < 1024) ? ($(window).actual('width') / 2) : ($(window).actual('width') / 4), ease: "expoScale(0.5,7,none)" }).then(function() {
        $('.search_menu').find('input[name=q]').focus();
        $('.search_menu').addClass('search_menu--open');
        $('body').addClass('no--scroll');
    });
});

$('body').on('click','.search_menu .close_btn', function(e) {
    e.preventDefault();
    gsap.to(".search_menu", { duration: .1, width: 0, ease: "expoScale(0.5,7,none)" }).then(function() {
        $('.search_menu').removeClass('search_menu--open');
        $('body').removeClass('no--scroll');
    });
});


const loadAjaxCart = () => {
    $.ajax({
        url: '/',
        success: function(res) {
            $('.cart_btn').html($(res).find('.cart_btn').html());
            $('.cart .cart_inner').html($(res).find('.cart_inner').html());

            $('.cart .cart_inner button[type=submit]').attr('disabled', false);
            $('.cart .cart_inner .remove_btn').css('opacity',1);
            $('.cart .cart_inner .remove_btn.loading').removeClass('loading');

            save_cart = false;
        },
        error: function() {
            $('.cart .cart_inner button[type=submit]').attr('disabled', false);
            $('.cart .cart_inner .remove_btn').css('opacity',1);
            $('.cart .cart_inner .remove_btn.loading').removeClass('loading');

            save_cart = false;
        }
    })
}

$('body').on('click', '.header .menu', function(e) {
    e.preventDefault();
    gsap.to(".navigation", { duration: .2, width: $(window).width() < 768 ? $(window).width() : ($(window).width() >= 768 && $(window).width() < 1024) ? ($(window).actual('width') / 2) : ($(window).actual('width') / 4), ease: "expoScale(0.5,7,none)" }).then(function() {
        $('.navigation').addClass('navigation--open');
        $('body').addClass('no--scroll');
    });
});

$('body').on('click', '.navigation .close_btn', function(e) {
    e.preventDefault();
    gsap.to(".navigation", { duration: .1, width: 0, ease: "expoScale(0.5,7,none)" }).then(function() {
        $('.navigation').removeClass('navigation--open');
        $('body').removeClass('no--scroll');
    });
});

$('body').on('click', '.navigation .currencies_menu > li > a', function(e) {
    e.preventDefault();

    const elm = $(this).siblings('ul');

    if ($(this).closest('li').hasClass('open')) {
        $(this).closest('li').removeClass('open');
        gsap.to(elm, {
            duration: .1,
            height: 0,
            ease: 'power1.out'
        });
    } else {
        $(this).closest('li').addClass('open');
        gsap.to(elm, {
            duration: .1,
            height: 'auto',
            ease: 'power1.out'
        });
    }
});

$('.navigation .navigation_middle .currencies_menu > li > ul > li > a').on('click', function(e) {
    e.preventDefault();

    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 'currency': $(this).data('currency') })
    }).then(response => {
        window.location.reload();
    }).catch((error) => {
        console.error('Error:', error);
    });
});

const searchFuncs = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const sizes = urlParams.get('sizes') !== null ? urlParams.get('sizes').split(';') : false;
    if (sizes && sizes.length > 0) {
        sizes.map((size) => {
            $('.search_menu .search_sizes > div[data-size="' + size + '"]').addClass('active');
        });
    }

    $('.search_menu .search_field input').on('keyup', function(e) {
        if (e.which === 13) {
            submitSearch();
        }
    });

    $('.search_menu .search_sizes > div').on('click', function(e) {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
        } else {
            $(this).addClass('active');
        }

        submitSearch();
    });

    const getSizes = () => {
        let sizes = [];
        $('.search_menu .search_sizes > div.active').each(function() {
            sizes.push($(this).data('size'));
        });

        return sizes.length > 0 ? sizes : false;
    }

    const submitSearch = () => {
        const action    = '/search';
        const sizeval   = getSizes();
        const searchval = $('.search_menu .search_field input').val() !== '' ? $('.search_menu .search_field input').val() : false;
        const searchurl = new URL(window.shopUrl + action);

        if (searchval) {
            searchurl.searchParams.append("q", searchval);
        } else if (sizeval) {
            searchurl.searchParams.append("q", "*");
        } else {
            searchurl.searchParams.append("q", "");
        }

        if (sizeval) searchurl.searchParams.append("sizes", sizeval.join(';'));
        searchurl.searchParams.append("type", "product");

        console.log(searchurl.href);
        window.location.href = searchurl.href;
    }
}

const saleBannerFuncs = () => {
    if ($('.sale_banner').length === 1) {
        var rollingTween = new TimelineMax();
        var time = 100;
        var $rollingTextgoLeft = $(".sale_banner .sale_boxes");
        var $text = $(".sale_banner .sale_boxes")

        function startRolling() {

            $text.css({width:"auto"});
            $text.width(width);
            var width = $text.width();

            rollingTween.to(".sale_banner .sale_boxes", time, {
                x: -width,
                ease: Linear.easeNone,
                repeat: -1
            })

            return rollingTween;
        }

        function rollingText(){
            $('.sale_banner  .sale_boxes').clone().appendTo(".sale_banner");
            startRolling();   
        }
        rollingText();

        function resizeCheck(){
            var progress = rollingTween.progress();
            rollingTween.time(0).kill();

            startRolling().progress(progress);
        };

        resizeCheck();
        $(window).resize(resizeCheck);
    }
}